export const dateToTimeNotation = (dateObject: Date): string =>
    new Intl.DateTimeFormat('nl-NL', { timeStyle: 'short' }).format(dateObject);
